window._ = require('lodash');
window.React = require('react');
window.ReactDOM = require('react-dom');
window.PropTypes = require('prop-types');
window.iFrameResize = require('iframe-resizer');
window.Cookies = require('js-cookie');
window.mobx = require('mobx');
window.mobxReact = require('mobx-react');
window.Promise = require('es6-promise').Promise;
window.Radium = require('radium');

// jQuery is requried for select2, please don't use for anything else, so we
// can get rid of it when we don't need select2 anymore.
window.$ = require('jquery');
window.select2 = require('select2');

// Object.assign polyfill
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';

            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

window.priceStrToCents = function(priceStr) {
    if (!priceStr) return 0;

    if (priceStr.lastIndexOf(',') > priceStr.lastIndexOf('.')) {
        priceStr = priceStr.replace('.', '').replace(',', '.');
    }

    return Math.round(100 * parseFloat(priceStr.replace(',', '')));
};

/**
 * Returns a valid price string for the given cents, with the thousands and
 * decimal seperators in the right place.
 */
window.centsToPriceStr = function(cents) {
    let floatVal = (cents / 100);

    return (
        floatVal.toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            .replace('.', '*')
            .replace(',', '.')
            .replace('*', ',')
    );
};

/**
 * Cleans a price value by removing invalid characters, but allows the
 * characters to be organized in an invalid way. This is handy to clean a price
 * input when the user is still editing it.
 */
window.cleanPrice = function(priceValue, props) {
    const allowedChars = ['\\d', ',', '\\.'];

    if (props && props.allowNegative) {
        allowedChars.push('-');
    }

    const invalidCharsRegex = new RegExp('[^' + allowedChars.join('') + ']', 'g');

    return priceValue.replace(invalidCharsRegex, '');
};

window.initTooltip = function(tooltipEl) {
    let tooltipPopoverEl = document.createElement('div');
    let cursorInsideIcon = false;
    let cursorInsidePopover = false;
    let removePopoverTimeoutID;

    tooltipPopoverEl.setAttribute('class', '_tooltip-popover');

    if (tooltipEl.hasAttribute('data-text-base64')) {
        // Decode base64 encoded strings for when the text contains HTML codes
        // that cannot be set as an attribute.
        tooltipPopoverEl.innerHTML = atob(tooltipEl.getAttribute('data-text-base64'));
    } else {
        tooltipPopoverEl.innerHTML = tooltipEl.getAttribute('data-text');
    }

    tooltipEl.addEventListener('mouseover', () => {
        cursorInsideIcon = true;
        document.body.appendChild(tooltipPopoverEl);

        tooltipPopoverEl.classList.remove('fadeout');
        tooltipPopoverEl.style.top = (
            (
                tooltipEl.offsetTop -
                tooltipPopoverEl.clientHeight -
                10
            ) + 'px'
        );
        tooltipPopoverEl.style.left = (tooltipEl.offsetLeft + 10) + 'px';

        tooltipPopoverEl.addEventListener('mouseover', () => {
            cursorInsidePopover = true;
            tooltipPopoverEl.classList.remove('fadeout');
        });

        tooltipPopoverEl.addEventListener('mouseout', () => {
            cursorInsidePopover = false;
            removeIfCursorOutsideIconAndPopover();
        });
    });

    function removeIfCursorOutsideIconAndPopover() {
        if (!cursorInsideIcon && !cursorInsidePopover) {
            tooltipPopoverEl.classList.add('fadeout');
        }

        clearTimeout(removePopoverTimeoutID);
        removePopoverTimeoutID = setTimeout(() => {
            if (!cursorInsideIcon && !cursorInsidePopover && document.body.contains(tooltipPopoverEl)) {
                document.body.removeChild(tooltipPopoverEl);
            }
        }, 700);
    }

    tooltipEl.addEventListener('mouseout', () => {
        cursorInsideIcon = false;
        removeIfCursorOutsideIconAndPopover();
    });
};

window.getShortMonthName = function(date) {
    const fullMonthNames = [
        gettext('1699'), gettext('1701'), gettext('1703'),
        gettext('1705'), gettext('1721'), gettext('1707'),
        gettext('1709'), gettext('1711'), gettext('1713'),
        gettext('1715'), gettext('1717'), gettext('1719')
    ];

    const shortMonthNames = _.map(fullMonthNames, (monthName) => {
        return monthName.slice(0, 3);
    });

    return shortMonthNames[date.getMonth()];
};

window.getFormattedDate = function(date, options) {
    // If date is null return blank string
    if (date.getTime() === new Date(null).getTime()) return '';

    function padWithZero(num) {
        return ('0' + num).slice(-2);
    }

    let output = (
        date.getDate() + ' ' +
        getShortMonthName(date) + ' ' +
        date.getFullYear()
    );

    if (_.get(options, 'showTime', true)) {
        output += (
            ' - ' +
            padWithZero(date.getHours()) + ':' +
            padWithZero(date.getMinutes())
        );
    }

    return output;
};
